module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix",
    attrs: {
      "id": "dispatchManage"
    }
  }, [_c('div', {
    staticClass: "section secLeft"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('p', {
    staticClass: "fl",
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v("检索条件：")]), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    staticStyle: {
      "width": "60px",
      "color": "#169BD5"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.clearFrom
    }
  }, [_vm._v("重置")])], 1), _vm._v(" "), _c('el-form', {
    ref: "searchForm",
    staticClass: "search-form",
    attrs: {
      "model": _vm.searchForm
    }
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "size": "small",
      "clearable": "",
      "placeholder": "品牌"
    },
    on: {
      "change": _vm.choseBrand
    },
    model: {
      value: (_vm.searchForm.brandId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "brandId", $$v)
      },
      expression: "searchForm.brandId"
    }
  }, _vm._l((_vm.brandList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.brandName,
        "value": item.brandId
      }
    }, [_vm._v(_vm._s(item.brandName))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "3px",
      "margin-bottom": "5px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "size": "small",
      "clearable": "",
      "placeholder": "品类"
    },
    on: {
      "change": _vm.choseCategory
    },
    model: {
      value: (_vm.searchForm.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "categoryId", $$v)
      },
      expression: "searchForm.categoryId"
    }
  }, _vm._l((_vm.categoryList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "selected": {
          'selected': index == 0
        },
        "label": item.categoryName,
        "value": item.categoryId
      }
    }, [_vm._v(_vm._s(item.categoryName))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "3px",
      "margin-bottom": "5px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "size": "small",
      "clearable": "",
      "placeholder": "型号"
    },
    on: {
      "change": _vm.choseModel
    },
    model: {
      value: (_vm.searchForm.modelId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "modelId", $$v)
      },
      expression: "searchForm.modelId"
    }
  }, _vm._l((_vm.modelList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "selected": {
          'selected': index == 0
        },
        "label": item.modelName,
        "value": item.modelId
      }
    }, [_vm._v(_vm._s(item.modelName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('el-select', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "size": "small",
      "filterable": "",
      "placeholder": "故障"
    },
    model: {
      value: (_vm.searchForm.faultSubclassId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "faultSubclassId", $$v)
      },
      expression: "searchForm.faultSubclassId"
    }
  }, _vm._l((_vm.faultopeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.faultSubclassName,
        "value": item.faultSubclassId
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-left": "3px",
      "margin-bottom": "5px"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "size": "small",
      "filterable": "",
      "placeholder": "订单类型"
    },
    model: {
      value: (_vm.searchForm.serviceType),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "serviceType", $$v)
      },
      expression: "searchForm.serviceType"
    }
  }, _vm._l((_vm.orderTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-left": "3px",
      "margin-bottom": "5px"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "size": "small",
      "filterable": "",
      "placeholder": "订单状态"
    },
    model: {
      value: (_vm.searchForm.adminStatus),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "adminStatus", $$v)
      },
      expression: "searchForm.adminStatus"
    }
  }, _vm._l((_vm.orderStatusList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('el-input', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "clearable": "",
      "size": "small",
      "placeholder": "请输入工程师姓名"
    },
    model: {
      value: (_vm.searchForm.name),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.name"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-left": "3px",
      "margin-bottom": "5px"
    },
    attrs: {
      "clearable": "",
      "size": "small",
      "placeholder": "请输入工程师账号"
    },
    model: {
      value: (_vm.searchForm.number),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "number", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.number"
    }
  })], 1), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "margin-bottom": "15px",
      "width": "100%",
      "font-size": "5px"
    },
    attrs: {
      "size": "small",
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": _vm.changePicker
    },
    model: {
      value: (_vm.value5),
      callback: function($$v) {
        _vm.value5 = $$v
      },
      expression: "value5"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.isSearch
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("检索")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "630px",
      "overflow-y": "auto",
      "padding": "3px"
    }
  }, [_c('ul', {
    staticStyle: {
      "box-shadow": "3px 3px 5px #ddd",
      "border": "1px dashed #eee"
    }
  }, _vm._l((_vm.orderLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "orderLi",
      class: {
        activeOrderLi: _vm.activeIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.selectOrder(item, index)
        }
      }
    }, [_c('dl', [_c('dt', [_c('ul', {
      staticClass: "orderStutasUl"
    }, [(item.modelName != null || item.colorName != null) ? _c('li', {
      staticClass: "orderStutasLi fl"
    }, [_vm._v(_vm._s(item.modelName) + " " + _vm._s(item.colorName))]) : _vm._e(), _vm._v(" "), _vm._l((item.faultSubclass), function(items, indexs) {
      return _c('li', {
        key: indexs,
        staticClass: "orderStutasLi fl"
      }, [(items != null && items.faultSubclassName != null) ? _c('span', [_vm._v(" " + _vm._s(items.faultSubclassName) + " ")]) : _vm._e()])
    }), _vm._v(" "), _c('li', {
      staticClass: "orderStutasLi fl"
    }, [_vm._v(" " + _vm._s(_vm._f("sysCodeFileter")(item.serviceType, 'order_type')))]), _vm._v(" "), _c('li', {
      staticClass: "fl"
    }, [(item.isTag == 1) ? _c('i', {
      staticClass: "el-icon-caret-top",
      staticStyle: {
        "color": "#409EFF",
        "font-size": "24px"
      },
      on: {
        "click": function($event) {
          return _vm.setOrderTagOpe(item, 0)
        }
      }
    }) : _c('i', {
      staticClass: "el-icon-caret-top",
      staticStyle: {
        "font-size": "24px"
      },
      on: {
        "click": function($event) {
          return _vm.setOrderTagOpe(item, 1)
        }
      }
    })]), _vm._v(" "), _c('li', {
      staticClass: "fl"
    }, [(item.isTag == -1) ? _c('i', {
      staticClass: "el-icon-caret-bottom",
      staticStyle: {
        "color": "#409EFF",
        "font-size": "24px"
      },
      on: {
        "click": function($event) {
          return _vm.setOrderTagOpe(item, 0)
        }
      }
    }) : _c('i', {
      staticClass: "el-icon-caret-bottom",
      staticStyle: {
        "font-size": "24px"
      },
      on: {
        "click": function($event) {
          return _vm.setOrderTagOpe(item, -1)
        }
      }
    })])], 2)])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("工单编号:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(item.orderNo))]), _vm._v(" "), _c('dd', {
      staticClass: "orderStutasLiN"
    }, [_vm._v(_vm._s(_vm._f("sysCodeFileter")(item.adminStatus, 'admin_status')))])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("详细地址:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(item.countyName) + _vm._s(item.address))])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("预约时间:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(item.onsiteDate) + " " + _vm._s(item.onsiteTimeStart) + "~" + _vm._s(item.onsiteTimeEnd))])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("最新回复:")]), _vm._v(" "), _c('dd', {
      staticClass: "ellipsis"
    }, [_vm._v(_vm._s(item.handleRemark))])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("工程师:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(item.staffName))]), _vm._v(" "), (item.adminStatus == 03) ? _c('dd', {
      staticClass: "showBtn",
      class: {
        activeBtn: _vm.activeIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.queryEgineerOpe1(item)
        }
      }
    }, [_vm._v("派单")]) : _vm._e(), _vm._v(" "), (item.adminStatus == 04 || item.adminStatus == 05 || item.adminStatus == 06 || item.adminStatus == 07) ? _c('dd', {
      staticClass: "showBtn",
      class: {
        activeBtn: _vm.activeIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.queryEgineerOpe1(item)
        }
      }
    }, [_vm._v("重置派单")]) : _vm._e()])])
  }), 0), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "small": "",
      "background": "",
      "current-page": _vm.searchForm.startRow,
      "page-sizes": [10, 20, 50, 100, 500, 1000],
      "page-size": _vm.searchForm.pageSize,
      "layout": " total, sizes , prev, pager, next,jumper",
      "total": _vm.orderPage.total
    },
    on: {
      "size-change": _vm.handleSizeChangeOrder,
      "current-change": _vm.handleCurrentChangeOrder
    }
  })], 1)])], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section secRight"
  }, [_c('el-form', {
    ref: "searchEngineer",
    staticClass: "clearfix",
    attrs: {
      "model": _vm.searchEngineer
    }
  }, [_c('el-input', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "搜索工程师"
    },
    on: {
      "input": _vm.queryEgineerOpe
    },
    model: {
      value: (_vm.searchEngineer.name),
      callback: function($$v) {
        _vm.$set(_vm.searchEngineer, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchEngineer.name"
    }
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "rightContent",
    staticStyle: {
      "overflow-y": "auto"
    }
  }, _vm._l((_vm.engineerLists), function(item, index) {
    return _c('li', {
      key: index,
      staticStyle: {
        "margin-bottom": "2px",
        "padding": "20px 0 10px"
      }
    }, [_c('div', {
      staticClass: "enginner-section"
    }, [_c('dl', [_c('dt', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.engineerStatus == 'DD') ? _c('dd', {
      staticStyle: {
        "padding": "0 5px",
        "border-radius": "3px",
        "height": "18px",
        "background-color": "#1abc9c",
        "color": "#fff",
        "margin-right": "5px"
      }
    }, [_vm._v("等待")]) : _vm._e(), _vm._v(" "), (item.engineerStatus == 'YCF') ? _c('dd', {
      staticStyle: {
        "padding": "0 5px",
        "border-radius": "3px",
        "height": "18px",
        "background-color": "#1abc9c",
        "color": "#fff",
        "margin-right": "5px"
      }
    }, [_vm._v("已出发")]) : _vm._e(), _vm._v(" "), (item.engineerStatus == 'YDD') ? _c('dd', {
      staticStyle: {
        "padding": "0 5px",
        "border-radius": "3px",
        "height": "18px",
        "background-color": "#1abc9c",
        "color": "#fff",
        "margin-right": "5px"
      }
    }, [_vm._v("已到达")]) : _vm._e(), _vm._v(" "), (item.engineerStatus == 'WXZ') ? _c('dd', {
      staticStyle: {
        "padding": "0 5px",
        "border-radius": "3px",
        "height": "18px",
        "background-color": "#1abc9c",
        "color": "#fff",
        "margin-right": "5px"
      }
    }, [_vm._v("维修中")]) : _vm._e(), _vm._v(" "), _c('dd', {
      staticStyle: {
        "padding": "0 5px",
        "border-radius": "3px",
        "height": "18px",
        "background-color": "#1abc9c",
        "color": "#fff",
        "margin-right": "5px"
      }
    }, [_vm._v(_vm._s(item.orderCount) + "单")])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("当前位置:")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(item.site))]), _vm._v(" "), _c('dd', {
      staticClass: "pointer-content"
    }, [(_vm.basicsAuth.send_orders) ? _c('el-button', {
      staticClass: "pointer",
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.changeDispatch(item)
        }
      }
    }, [_vm._v("指派")]) : _vm._e()], 1)])])])
  }), 0), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "width": "40%"
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "small": "",
      "background": "",
      "current-page": _vm.engineerPage.startRow,
      "page-sizes": [2, 5, 10],
      "page-size": _vm.engineerPage.pageSize,
      "layout": " total, sizes, prev, pager, next",
      "total": _vm.engineerPage.total
    },
    on: {
      "size-change": _vm.handleSizeChangeEngineer,
      "current-change": _vm.handleCurrentChangeEngineer
    }
  })], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "padding": "5px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "900px",
      "padding": "5px"
    },
    attrs: {
      "id": "atlas"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-4ebcea99","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dispatchOrder/dispatchManage.vue
// module id = 1665
// module chunks = 0